// extracted by mini-css-extract-plugin
module.exports = {"dot-chevron":"DotChevron_dot-chevron__c8mk5","dot":"DotChevron_dot__TL0vS","is-open":"DotChevron_is-open__xOm3m"};